import React from 'react';

const Disclaimer = () => {
  return (
    <div className="bg-white min-h-screen pt-24 pb-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif text-4xl text-gray-900 mb-8">Nutrition & Recipe Disclaimer</h1>
        
        <div className="prose prose-lg prose-ube text-gray-700 space-y-6">
          <p>
            The recipes and nutritional information provided by UBEA and the UBEA Test Kitchen are for general informational purposes only.
          </p>

          <h2 className="font-serif text-2xl text-gray-900 mt-12 mb-4">1. Estimated Nutrition</h2>
          <p>
            Any nutritional figures provided on our website are estimates calculated from ingredient databases and are <strong>not laboratory-tested or verified</strong>. Actual nutritional values will vary significantly based on the exact brands of ingredients you use, natural variations in fresh produce, substitution of ingredients, and your specific portion sizes.
          </p>

          <h2 className="font-serif text-2xl text-gray-900 mt-12 mb-4">2. Product Packaging vs. Recipe Estimates</h2>
          <p>
            The nutritional information printed on physical UBEA product packaging is determined separately by certified laboratory analysis in compliance with FDA regulations. In any instance where recipe estimates appear to differ from product packaging, the physical product packaging should be considered the authoritative source for that specific ingredient.
          </p>

          <h2 className="font-serif text-2xl text-gray-900 mt-12 mb-4">3. Not Medical or Dietary Advice</h2>
          <p>
            UBEA does not provide medical or dietary advice. Terms such as 'Keto-friendly', 'Sugar-Free', 'High-Protein', or 'Wellness' are used to describe the intent of the recipe as written. Your results, including blood sugar impact or dietary compliance, depend entirely on the exact products and portions you consume. Consult a qualified healthcare professional or registered dietitian for medical or dietary decisions.
          </p>

          <h2 className="font-serif text-2xl text-gray-900 mt-12 mb-4">4. Allergen Note</h2>
          <p>
            Our recipes may contain or recommend ingredients including, but not limited to: <strong>milk, eggs, tree nuts, peanuts, wheat, and soy</strong>. It is your responsibility to check every ingredient label for your specific allergy or dietary needs before preparation and consumption.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;